// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/about-us-bg-desktop.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/about-us-bg-mobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/about-us-bg-tab.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Raleway', 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
  color: unset;
  text-decoration: unset;
}

.nav-bar {
  width: 100%;
  height: 80px;
  left: 0px;
  top: 0px;
  background: #232323;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 1;
}

.nav-bar-right {
  margin-right: 120px;
}

.nav-bar-left {
  margin-left: 120px;
}

.nav-bar-middle {
  color: #FFFFFF;
  display: flex;
  column-gap: 50px;
}

.nav-item {
  cursor: pointer
}

.nav-item:active {
  color: #CC2D2D
}

.grey-button {
  color: #FFFFFF;
  background: #393939;
  padding: 15px 30px;
  border-radius: 26px;
  border: none;
  cursor: pointer
}

.grey-button:active {
  background: #474747;
}

.red-button {
  color: #FFFFFF;
  background: #CC2D2D;
  padding: 15px 30px;
  border-radius: 26px;
  border: none;
  cursor: pointer;
  width: 168px;
  font-size: 16px;
  height: 49px;
}

.red-button:active {
  background: #d04a4a;
  ;
}

.white-button {
  color: #CC2D2D;
  background: #FFFFFF;
  padding: 15px 30px;
  border-radius: 26px;
  border: none;
  cursor: pointer;
  width: 168px;
  font-weight: 600;
  font-size: 20px;
  height: 49px;
}

.white-button:active {
  background: rgb(255, 207, 207);
  ;
}


.menu-button {
  color: #FFFFFF;
  background-color: #393939;
  /* padding: 15px 30px; */
  border-radius: 26px;
  border: none;
  cursor: pointer;
  display: block;
  height: 44px;
  width: 44px;
  border-radius: 50%;
  display: none;
}

.menu-button:active {
  background-color: #474747;

}

.app-title {
  height: 754px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-title-sub {
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.app-title-main {
  font-size: 84px;
  font-weight: 600;
  line-height: 99px;
  letter-spacing: 0em;
  width: 903px;
  text-align: center;
}

.app-description {
  display: flex;
  height: 700px;
  align-items: center;
  background: #CC2D2D;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom;
  background-repeat: no-repeat;
}

.app-description-text {
  display: flex;
  flex-wrap: wrap;
  row-gap: 75px;
}

.app-description-text-left {
  width: 473px;
  color: #FFFFFF;
  text-align: left;
  font-weight: 500;
  font-size: 64px;
  line-height: 110%;
  margin-left: 121px;
  margin-right: 121px;
  /* position: relative; */
  /* top: -10px; */
}

.app-description-text-right {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  width: 554px;
  color: #FFFFFF;
  text-align: left;
  line-height: 140%;
  margin-left: 39px;
  position: relative;
  top: 10px;
}

.app-description-right {
  display: flex;
  width: 554px;
}

.white-separator {
  width: 13px;
  height: 88px;
  background: #FFFFFF;
  position: relative;
  top: 15px;
}

.background-logo {
  position: absolute;
  left: 19.38%;
  right: 31.15%;
  opacity: 0.1;
}

.our-offerings-body {
  padding-top: 120px;
  padding-bottom: 120px;
  background: #F5F5F5;
}

.general-title {
  font-size: 18px;
  color: #CC2D2D;
  letter-spacing: 0.24em;
}

.general-titile-description {
  font-size: 48px;
  line-height: 120%;
  font-weight: 500;
  color: #000000;
  width: 679px;
  margin: 1em auto 2em auto;
}

.our-offerings-list {
  background: #FFFFFF;
  margin: 120px;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
}

.our-offerings-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 3em 0;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.our-offerings-text {
  margin: auto 0;
}

.our-offerings-text-title {
  width: 10em;
  font-weight: 600;
  font-size: 40px;
  line-height: 140%;
  text-align: left;
}

.our-offerings-text-description {
  font-size: 20px;
  line-height: 140%;
  width: 20em;
  text-align: left;
}

.offering-image {
  width: 65%;
  height: auto;
  margin-left: -10em;
}

.faq-title {
  font-weight: 500;
  font-size: 48px;
  line-height: 120%;
  width: 631px;
  margin: 5% auto;
}

.faq-question-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  margin-bottom: 1em;
  cursor: pointer;
}

.faq-questions-container {
  margin: auto;
  text-align: left;
  width: 50%;
}

.faq-question {
  margin: 2em 0;
}

.faq-question-answer {
  transition: 0.4s;
}

.footer-container-mobile {
  height: 466px;
  background: #232323;
  display: flex;
  flex-direction: column;
  justify-content: center;
  display: none;
  height: unset;
  padding-top: 1em;
}

.footer-upper-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3em;
  row-gap: 2em;
}

.footer-lower-container {
  color: #FFFFFFB2;
  padding-bottom: 3em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap-reverse;
  row-gap: 1em;
  margin-top: 1em;
}

.footer-lower-text {
  color: #FFFFFFB2;
  /* font-family: 'Raleway'; */
  /* margin-top: auto;
  margin-bottom: 3em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap-reverse;
  row-gap: 1em;
  margin-top: 1em; */
}


.footer-logo {
  width: 20em
}

.footer-slogan {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 140%;
  padding-top: 1em;
  text-align: left;
  padding-left: 2.5em;
}

.footer-newsletter {
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.2em;
  color: #FFFFFF;
}

.footer-newsletter div {
  padding: 0.5em 0;
}

.subscribe-input {
  height: 40px;
  width: 300px;
  background: #393939;
  color: #FFFFFF;
  border: none;
  border-radius: 10px;
  padding-left: 1em;
}

.newsletter-button {
  background: #CC2D2D;
  border: none;
  color: white;
  height: 3em;
  border-radius: 10px;
  margin-left: 1em;
  width: 3em;
}

#newsletter::placeholder {
  color: #FFFFFF4D;
  opacity: 1;
}

.footer-navigation-header {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 0.2em;
  text-align: left
}

.footer-navigation-list {
  color: #FFFFFF;
  font-size: 16px;
  text-align: left;
  line-height: 140%;
  margin-top: 1.5em;
  cursor: pointer;
}

.footer-navigation-list div {
  margin: .5em 0;
}

.general-container {
  padding: 5em 2em;
}

.general-container-grey {
  padding: 5em 2em;
  background: #F5F5F5;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 2em;
}

.contact-form div {
  display: flex;
  flex-direction: column;
  margin: auto;
}

.contact-form label {
  margin-right: auto;
  margin-bottom: 0.5em;
  font-weight: 500;
}

.contact-form input {
  width: 30em;
  height: 3em;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding-left: 1em;
}

.contact-form textarea {
  width: 30em;
  height: 7em;
  border: 1px solid #D9D9D9;
  border-radius: 10px;
  padding-left: 1em;
}

input::placeholder {
  font-family: 'Raleway';
}

#contactMessage::placeholder {
  font-family: 'Raleway';
}

.blog-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2em;
}

.blog-card {
  width: 386px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 1em;
}


.blog-image {
  height: auto;
  width: -webkit-fill-available;
  padding-bottom: 1.5em;
  border-radius: 20px;
}

.blog-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  padding-bottom: 1em
}

.blog-content {
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  margin-bottom: 1em;
}

.side-drawer-container {
  background: #CC2D2D;
  height: 100vh;
}

.side-drawer-header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1em;
}

.side-drawer-list-container {
  padding: 0 1em;
}

.side-drawer-list-item {
  font-size: 32px;
  line-height: 38px;
  line-height: 120%;
  color: #FFFFFF;
  text-align: left;
  margin: 1em 0;
}

.sidebar-background-logo {
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.1;
}

.footer-container-desktop {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 3em;
  grid-row-gap: -4em;
  background: #232323;
  /* padding: 0 5em; */
  /* margin: 1em 0; */
  padding-top: 5em;
  padding-bottom: 3em;
}

/* For Mobile Phones Portrait or Landscape View */
@media screen and (max-device-width: 640px) {

  .nav-bar-left {
    margin-left: 20px;
  }

  .nav-bar-middle {
    display: none;
  }

  .nav-bar-right {
    margin-right: 20px;
  }

  .navbar-contact {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .app-title-sub {
    font-size: 14px;
    width: 209px;
    line-height: 140%;
  }

  .app-title-main {
    font-size: 36px;
    line-height: 42px;
    width: 274px;
    margin-top: 40px
  }

  .app-description {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

  .app-description-text-left {
    width: unset;
    font-size: 36px;
    line-height: 110%;
    margin-left: 20px;
  }

  .app-description-text-right {
    font-size: 15px;
    width: 299px;
    margin-left: 20px;
  }

  .app-description-right {
    margin-left: 24px;
    width: unset;
  }

  .background-logo {
    left: 0;
    right: 0;
  }

  .our-offerings-body {
    padding-top: 60px;
    padding-bottom: 60px;
    background: #F5F5F5;
  }

  .our-offerings-list {
    margin: 20px;
  }

  .general-titile-description {
    width: 297px;
    font-size: 32px;
    font-weight: 500;
    line-height: 120%;
  }

  .our-offerings-text-title {
    font-size: 24px;
  }

  .our-offerings-text-description {
    font-size: 14px;
  }

  .offering-image {
    margin: auto;
  }

  .faq-title {
    font-size: 32px;
    width: 289px;
  }

  .faq-questions-container {
    width: 80%;
  }

  .contact-form input {
    width: 20em;
    padding-left: 1em;
  }

  .contact-form textarea {
    width: 20em;
    padding-left: 1em;
  }

  .footer-navigation-list {
    text-align: center;
  }

  .footer-container-desktop {
    display: none;
  }

  .footer-container-mobile {
    display: block;
  }

  .footer-slogan {
    text-align: center;
    padding-left: unset;
  }

}

/* For Tablet View */
@media screen and (min-device-width: 640px) and (max-device-width: 1024px) {

  .footer-container-mobile {
    display: block;
  }

  .footer-slogan {
    padding-left: 1.5em;
  }

  .footer-container-desktop {
    display: none;
  }

  .nav-bar-left {
    margin-left: 20px;
  }

  .nav-bar-middle {
    display: none;
  }

  .navbar-contact {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .nav-bar-right {
    margin-right: 30px;
  }

  .app-title-sub {
    font-size: 20px;
    width: 513px;
    line-height: 140%;
  }

  .app-title-main {
    font-size: 64px;
    line-height: 75px;
    width: 484px;
    margin-top: 60px
  }

  .app-description {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .app-description-text-left {
    width: unset;
    margin-left: 40px;
  }

  .app-description-text-right {
    font-size: 15px;
    width: 299px;
    margin-left: 20px;
  }

  .app-description-right {
    margin-left: 24px;
    width: unset
  }

  .our-offerings-list {
    margin: 40px;
  }

  .faq-title {
    font-size: 32px;
    width: 289px;
  }

}




/* ------------------------GRID------------------------------ */
.div1 {
  grid-area: 1 / 1 / 2 / 2;
  width: 22em;
  margin-left: auto;
}

.div2 {
  grid-area: 2 / 1 / 3 / 2;
  color: #FFFFFFB2;
  margin-top: auto;
  /* margin-bottom: 3em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap-reverse;
  row-gap: 1em;
  margin-top: 1em; */

}

.div3 {
  grid-area: 1 / 2 / 2 / 3;
  text-align: left;
}

.div4 {
  grid-area: 2 / 2 / 3 / 3;
  color: #FFFFFFB2;
  margin-top: auto;
}

.div5 {
  grid-area: 1 / 3 / 2 / 4;
}

.div6 {
  grid-area: 2 / 3 / 3 / 4;
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8BAA8B;;AAEhC;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yDAAgE;EAChE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B;;;;;;;oBAOkB;AACpB;;;AAGA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,YAAY;EACZ,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ;EACF;;EAEA;IACE,yDAA+D;EACjE;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;;AAEA,oBAAoB;AACpB;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ;EACF;;EAEA;IACE,yDAA4D;EAC9D;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;AAEF;;;;;AAKA,+DAA+D;AAC/D;EACE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB;;;;;;oBAMkB;;AAEpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Raleway', 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  color: unset;\n  text-decoration: unset;\n}\n\n.nav-bar {\n  width: 100%;\n  height: 80px;\n  left: 0px;\n  top: 0px;\n  background: #232323;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: fixed;\n  z-index: 1;\n}\n\n.nav-bar-right {\n  margin-right: 120px;\n}\n\n.nav-bar-left {\n  margin-left: 120px;\n}\n\n.nav-bar-middle {\n  color: #FFFFFF;\n  display: flex;\n  column-gap: 50px;\n}\n\n.nav-item {\n  cursor: pointer\n}\n\n.nav-item:active {\n  color: #CC2D2D\n}\n\n.grey-button {\n  color: #FFFFFF;\n  background: #393939;\n  padding: 15px 30px;\n  border-radius: 26px;\n  border: none;\n  cursor: pointer\n}\n\n.grey-button:active {\n  background: #474747;\n}\n\n.red-button {\n  color: #FFFFFF;\n  background: #CC2D2D;\n  padding: 15px 30px;\n  border-radius: 26px;\n  border: none;\n  cursor: pointer;\n  width: 168px;\n  font-size: 16px;\n  height: 49px;\n}\n\n.red-button:active {\n  background: #d04a4a;\n  ;\n}\n\n.white-button {\n  color: #CC2D2D;\n  background: #FFFFFF;\n  padding: 15px 30px;\n  border-radius: 26px;\n  border: none;\n  cursor: pointer;\n  width: 168px;\n  font-weight: 600;\n  font-size: 20px;\n  height: 49px;\n}\n\n.white-button:active {\n  background: rgb(255, 207, 207);\n  ;\n}\n\n\n.menu-button {\n  color: #FFFFFF;\n  background-color: #393939;\n  /* padding: 15px 30px; */\n  border-radius: 26px;\n  border: none;\n  cursor: pointer;\n  display: block;\n  height: 44px;\n  width: 44px;\n  border-radius: 50%;\n  display: none;\n}\n\n.menu-button:active {\n  background-color: #474747;\n\n}\n\n.app-title {\n  height: 754px;\n  background: #FFFFFF;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.app-title-sub {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 23px;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.app-title-main {\n  font-size: 84px;\n  font-weight: 600;\n  line-height: 99px;\n  letter-spacing: 0em;\n  width: 903px;\n  text-align: center;\n}\n\n.app-description {\n  display: flex;\n  height: 700px;\n  align-items: center;\n  background: #CC2D2D;\n  background-image: url(\"./assets/images/about-us-bg-desktop.svg\");\n  background-position: bottom;\n  background-repeat: no-repeat;\n}\n\n.app-description-text {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 75px;\n}\n\n.app-description-text-left {\n  width: 473px;\n  color: #FFFFFF;\n  text-align: left;\n  font-weight: 500;\n  font-size: 64px;\n  line-height: 110%;\n  margin-left: 121px;\n  margin-right: 121px;\n  /* position: relative; */\n  /* top: -10px; */\n}\n\n.app-description-text-right {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  width: 554px;\n  color: #FFFFFF;\n  text-align: left;\n  line-height: 140%;\n  margin-left: 39px;\n  position: relative;\n  top: 10px;\n}\n\n.app-description-right {\n  display: flex;\n  width: 554px;\n}\n\n.white-separator {\n  width: 13px;\n  height: 88px;\n  background: #FFFFFF;\n  position: relative;\n  top: 15px;\n}\n\n.background-logo {\n  position: absolute;\n  left: 19.38%;\n  right: 31.15%;\n  opacity: 0.1;\n}\n\n.our-offerings-body {\n  padding-top: 120px;\n  padding-bottom: 120px;\n  background: #F5F5F5;\n}\n\n.general-title {\n  font-size: 18px;\n  color: #CC2D2D;\n  letter-spacing: 0.24em;\n}\n\n.general-titile-description {\n  font-size: 48px;\n  line-height: 120%;\n  font-weight: 500;\n  color: #000000;\n  width: 679px;\n  margin: 1em auto 2em auto;\n}\n\n.our-offerings-list {\n  background: #FFFFFF;\n  margin: 120px;\n  border-radius: 30px;\n  display: flex;\n  flex-direction: column;\n}\n\n.our-offerings-item {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin: 3em 0;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n\n.our-offerings-text {\n  margin: auto 0;\n}\n\n.our-offerings-text-title {\n  width: 10em;\n  font-weight: 600;\n  font-size: 40px;\n  line-height: 140%;\n  text-align: left;\n}\n\n.our-offerings-text-description {\n  font-size: 20px;\n  line-height: 140%;\n  width: 20em;\n  text-align: left;\n}\n\n.offering-image {\n  width: 65%;\n  height: auto;\n  margin-left: -10em;\n}\n\n.faq-title {\n  font-weight: 500;\n  font-size: 48px;\n  line-height: 120%;\n  width: 631px;\n  margin: 5% auto;\n}\n\n.faq-question-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 120%;\n  margin-bottom: 1em;\n  cursor: pointer;\n}\n\n.faq-questions-container {\n  margin: auto;\n  text-align: left;\n  width: 50%;\n}\n\n.faq-question {\n  margin: 2em 0;\n}\n\n.faq-question-answer {\n  transition: 0.4s;\n}\n\n.footer-container-mobile {\n  height: 466px;\n  background: #232323;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  display: none;\n  height: unset;\n  padding-top: 1em;\n}\n\n.footer-upper-container {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 3em;\n  row-gap: 2em;\n}\n\n.footer-lower-container {\n  color: #FFFFFFB2;\n  padding-bottom: 3em;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap-reverse;\n  row-gap: 1em;\n  margin-top: 1em;\n}\n\n.footer-lower-text {\n  color: #FFFFFFB2;\n  /* font-family: 'Raleway'; */\n  /* margin-top: auto;\n  margin-bottom: 3em;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap-reverse;\n  row-gap: 1em;\n  margin-top: 1em; */\n}\n\n\n.footer-logo {\n  width: 20em\n}\n\n.footer-slogan {\n  font-weight: 500;\n  font-size: 16px;\n  color: #FFFFFF;\n  line-height: 140%;\n  padding-top: 1em;\n  text-align: left;\n  padding-left: 2.5em;\n}\n\n.footer-newsletter {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 140%;\n  letter-spacing: 0.2em;\n  color: #FFFFFF;\n}\n\n.footer-newsletter div {\n  padding: 0.5em 0;\n}\n\n.subscribe-input {\n  height: 40px;\n  width: 300px;\n  background: #393939;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 10px;\n  padding-left: 1em;\n}\n\n.newsletter-button {\n  background: #CC2D2D;\n  border: none;\n  color: white;\n  height: 3em;\n  border-radius: 10px;\n  margin-left: 1em;\n  width: 3em;\n}\n\n#newsletter::placeholder {\n  color: #FFFFFF4D;\n  opacity: 1;\n}\n\n.footer-navigation-header {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.5);\n  letter-spacing: 0.2em;\n  text-align: left\n}\n\n.footer-navigation-list {\n  color: #FFFFFF;\n  font-size: 16px;\n  text-align: left;\n  line-height: 140%;\n  margin-top: 1.5em;\n  cursor: pointer;\n}\n\n.footer-navigation-list div {\n  margin: .5em 0;\n}\n\n.general-container {\n  padding: 5em 2em;\n}\n\n.general-container-grey {\n  padding: 5em 2em;\n  background: #F5F5F5;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n}\n\n.contact-form div {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n}\n\n.contact-form label {\n  margin-right: auto;\n  margin-bottom: 0.5em;\n  font-weight: 500;\n}\n\n.contact-form input {\n  width: 30em;\n  height: 3em;\n  border: 1px solid #D9D9D9;\n  border-radius: 10px;\n  padding-left: 1em;\n}\n\n.contact-form textarea {\n  width: 30em;\n  height: 7em;\n  border: 1px solid #D9D9D9;\n  border-radius: 10px;\n  padding-left: 1em;\n}\n\ninput::placeholder {\n  font-family: 'Raleway';\n}\n\n#contactMessage::placeholder {\n  font-family: 'Raleway';\n}\n\n.blog-list {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 2em;\n}\n\n.blog-card {\n  width: 386px;\n  background: #FFFFFF;\n  border-radius: 20px;\n  padding: 1em;\n}\n\n\n.blog-image {\n  height: auto;\n  width: -webkit-fill-available;\n  padding-bottom: 1.5em;\n  border-radius: 20px;\n}\n\n.blog-title {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 28px;\n  padding-bottom: 1em\n}\n\n.blog-content {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 130%;\n  margin-bottom: 1em;\n}\n\n.side-drawer-container {\n  background: #CC2D2D;\n  height: 100vh;\n}\n\n.side-drawer-header {\n  height: 80px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 1em;\n}\n\n.side-drawer-list-container {\n  padding: 0 1em;\n}\n\n.side-drawer-list-item {\n  font-size: 32px;\n  line-height: 38px;\n  line-height: 120%;\n  color: #FFFFFF;\n  text-align: left;\n  margin: 1em 0;\n}\n\n.sidebar-background-logo {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  opacity: 0.1;\n}\n\n.footer-container-desktop {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  grid-column-gap: 3em;\n  grid-row-gap: -4em;\n  background: #232323;\n  /* padding: 0 5em; */\n  /* margin: 1em 0; */\n  padding-top: 5em;\n  padding-bottom: 3em;\n}\n\n/* For Mobile Phones Portrait or Landscape View */\n@media screen and (max-device-width: 640px) {\n\n  .nav-bar-left {\n    margin-left: 20px;\n  }\n\n  .nav-bar-middle {\n    display: none;\n  }\n\n  .nav-bar-right {\n    margin-right: 20px;\n  }\n\n  .navbar-contact {\n    display: none;\n  }\n\n  .menu-button {\n    display: block;\n  }\n\n  .app-title-sub {\n    font-size: 14px;\n    width: 209px;\n    line-height: 140%;\n  }\n\n  .app-title-main {\n    font-size: 36px;\n    line-height: 42px;\n    width: 274px;\n    margin-top: 40px\n  }\n\n  .app-description {\n    background-image: url(\"./assets/images/about-us-bg-mobile.svg\");\n  }\n\n  .app-description-text-left {\n    width: unset;\n    font-size: 36px;\n    line-height: 110%;\n    margin-left: 20px;\n  }\n\n  .app-description-text-right {\n    font-size: 15px;\n    width: 299px;\n    margin-left: 20px;\n  }\n\n  .app-description-right {\n    margin-left: 24px;\n    width: unset;\n  }\n\n  .background-logo {\n    left: 0;\n    right: 0;\n  }\n\n  .our-offerings-body {\n    padding-top: 60px;\n    padding-bottom: 60px;\n    background: #F5F5F5;\n  }\n\n  .our-offerings-list {\n    margin: 20px;\n  }\n\n  .general-titile-description {\n    width: 297px;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 120%;\n  }\n\n  .our-offerings-text-title {\n    font-size: 24px;\n  }\n\n  .our-offerings-text-description {\n    font-size: 14px;\n  }\n\n  .offering-image {\n    margin: auto;\n  }\n\n  .faq-title {\n    font-size: 32px;\n    width: 289px;\n  }\n\n  .faq-questions-container {\n    width: 80%;\n  }\n\n  .contact-form input {\n    width: 20em;\n    padding-left: 1em;\n  }\n\n  .contact-form textarea {\n    width: 20em;\n    padding-left: 1em;\n  }\n\n  .footer-navigation-list {\n    text-align: center;\n  }\n\n  .footer-container-desktop {\n    display: none;\n  }\n\n  .footer-container-mobile {\n    display: block;\n  }\n\n  .footer-slogan {\n    text-align: center;\n    padding-left: unset;\n  }\n\n}\n\n/* For Tablet View */\n@media screen and (min-device-width: 640px) and (max-device-width: 1024px) {\n\n  .footer-container-mobile {\n    display: block;\n  }\n\n  .footer-slogan {\n    padding-left: 1.5em;\n  }\n\n  .footer-container-desktop {\n    display: none;\n  }\n\n  .nav-bar-left {\n    margin-left: 20px;\n  }\n\n  .nav-bar-middle {\n    display: none;\n  }\n\n  .navbar-contact {\n    display: none;\n  }\n\n  .menu-button {\n    display: block;\n  }\n\n  .nav-bar-right {\n    margin-right: 30px;\n  }\n\n  .app-title-sub {\n    font-size: 20px;\n    width: 513px;\n    line-height: 140%;\n  }\n\n  .app-title-main {\n    font-size: 64px;\n    line-height: 75px;\n    width: 484px;\n    margin-top: 60px\n  }\n\n  .app-description {\n    background-image: url(\"./assets/images/about-us-bg-tab.svg\");\n  }\n\n  .app-description-text-left {\n    width: unset;\n    margin-left: 40px;\n  }\n\n  .app-description-text-right {\n    font-size: 15px;\n    width: 299px;\n    margin-left: 20px;\n  }\n\n  .app-description-right {\n    margin-left: 24px;\n    width: unset\n  }\n\n  .our-offerings-list {\n    margin: 40px;\n  }\n\n  .faq-title {\n    font-size: 32px;\n    width: 289px;\n  }\n\n}\n\n\n\n\n/* ------------------------GRID------------------------------ */\n.div1 {\n  grid-area: 1 / 1 / 2 / 2;\n  width: 22em;\n  margin-left: auto;\n}\n\n.div2 {\n  grid-area: 2 / 1 / 3 / 2;\n  color: #FFFFFFB2;\n  margin-top: auto;\n  /* margin-bottom: 3em;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap-reverse;\n  row-gap: 1em;\n  margin-top: 1em; */\n\n}\n\n.div3 {\n  grid-area: 1 / 2 / 2 / 3;\n  text-align: left;\n}\n\n.div4 {\n  grid-area: 2 / 2 / 3 / 3;\n  color: #FFFFFFB2;\n  margin-top: auto;\n}\n\n.div5 {\n  grid-area: 1 / 3 / 2 / 4;\n}\n\n.div6 {\n  grid-area: 2 / 3 / 3 / 4;\n  margin-top: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
